export default {
  'wp-content-frame': {
    name: 'Внешний контент',
    settings: {
      header: 'Заголовок',
      source: 'URL источника'
    }
  }
}
